var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37.9586,
    cy: 38.389,
    r: 37.8802,
    fill: "#FF020A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7981 36.9686L28.2021 18.9955C27.127 18.3633 25.7828 19.1535 25.7828 20.4164V56.3626C25.7828 57.6255 27.127 58.4157 28.2021 57.7835L58.7981 39.8104C59.8732 39.1782 59.8732 37.5992 58.7981 36.9686Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon);
export default __webpack_public_path__ + "static/media/PlayIcon.b302a5600bc705725380953d35846eca.svg";
export { ForwardRef as ReactComponent };